module.exports = __webpack_public_path__ + "img/profile-2024.23309975.jpg";